export const getDefaultLanguageFilters = (userLanguage: string) => {
  const languageFilters: { [key: string]: string[] } = {
    'es': ['es', 'es-es', 'en-us'],
    'mx': ['es-mx', 'es', 'es-es', 'en-us'],
    'ar': ['es-ar', 'es', 'es-es', 'en-us'],
    'ca': ['ca-es', 'en-us'],
    'vsv': ['vsv', 'es-es', 'en-us'],
    'gl': ['gl-es', 'es-es', 'en-us'],
    'eu': ['eu-es', 'es-es', 'en-us']
  };
  return languageFilters[userLanguage.toLowerCase()] || ['es', 'es-es', 'en-us'];
}; 